import { Table, type TableProps } from "@mantine/core";
import type { ReactNode } from "react";

import classes from "./TableFrame.module.css";

export interface TableFrameProps extends TableProps {
  /**
   * The paging row ("Items per page", "Showing a - b of n", the pages). The live app lays it
   * under the bordered box, not inside it (design-system.md 3.7, screenshot 09), so it renders
   * there, as a flex row with the items spread.
   */
  footer?: ReactNode;
  /** A table wider than its box scrolls sideways in it, rather than being clipped (a phone). */
  scroll?: boolean | undefined;
}

/**
 * A data table in the live app's frame (design-system.md 3.7): a 12px-radius bordered wrapper,
 * 36px head cells on the hover surface in 12px/500, 52px rows that highlight on hover, and the
 * page footer under the box when the caller gives one.
 */
export function TableFrame({ children, footer, scroll = false, ...table }: TableFrameProps) {
  return (
    <div>
      <div className={classes.frame} data-scroll={scroll || undefined}>
        <Table
          {...table}
          classNames={{ th: classes.th, td: classes.td, tr: classes.tr }}
          verticalSpacing={0}
          horizontalSpacing={10}
        >
          {children}
        </Table>
      </div>
      {footer === undefined ? null : <div className={classes.footer}>{footer}</div>}
    </div>
  );
}
